import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { coverAnnounce } from '@/api/gmtool/packageCode';
import { gmTool } from "@/mixins/index";
export default {
  mixins: [gmTool],
  props: {
    prod: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    serverList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    channellAllList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      paramsData: {
        id: '',
        label: 0,
        server_rangeStart: '',
        server_rangeEnd: '',
        // channelStart: '',
        server_range: [],
        // channelEnd: '',
        channel: '',
        channel_list: [],
        pause_start_time: '',
        // pause_duration: '',
        priority: '',
        force_push: '',
        start_time: '',
        main_content: [],
        end_time: '',
        pause: 0,
        show_switch: '',
        type: ''
      },
      isStart: false,
      isEnd: false,
      dialogShow: false,
      reqLoading: false,
      whetherNot: [{
        label: this.$t('yes'),
        value: 1
      }, {
        label: this.$t('no'),
        value: 2
      }],
      rules: {
        title: [{
          required: true,
          message: this.$t('pleaseInputTitle'),
          trigger: "blur"
        }],
        label: [{
          required: true,
          message: this.$t('pleaseInputIdentifier'),
          trigger: "blur"
        }],
        priority: [{
          required: true,
          message: this.$t('pleaseInputPriorityValue'),
          trigger: "blur"
        }],
        force_push: [{
          required: true,
          message: this.$t('pleaseSelectIsStrongReminder'),
          trigger: "blur"
        }],
        start_time: [{
          required: true,
          message: this.$t('pleaseSelectStartTime'),
          trigger: "blur"
        }],
        end_time: [{
          required: true,
          message: this.$t('pleaseSelectEndTime'),
          trigger: "blur"
        }],
        main_content: [{
          required: true,
          message: this.$t('pleaseAddAnnouncementContent'),
          trigger: "blur"
        }],
        content: [{
          required: true,
          message: this.$t('pleaseInputContent'),
          trigger: "blur"
        }],
        server_ids: [{
          required: true,
          message: this.$t('pleaseSelectServer'),
          trigger: "blur"
        }],
        channelStart: [{
          required: true,
          message: this.$t('pleaseSelectStartServer'),
          trigger: "blur"
        }],
        channelEnd: [{
          required: true,
          message: this.$t('pleaseSelectEndServer'),
          trigger: "blur"
        }],
        pause_start_time: [{
          required: true,
          message: this.$t('pleaseInputServerStopStartTime'),
          trigger: "blur"
        }],
        // pause_duration: [{ required: true, message: "请输入持续时间", trigger: "blur" }],
        language: [{
          required: true,
          message: this.$t('pleaseSelectLanguage'),
          trigger: "blur"
        }],
        pause: [{
          required: true,
          message: this.$t('pleaseSelectType'),
          trigger: "blur"
        }],
        server_rangeStart: [{
          required: true,
          message: this.$t('pleaseSelectStartServer'),
          trigger: "blur"
        }],
        server_rangeEnd: [{
          required: true,
          message: this.$t('pleaseSelectEndServer'),
          trigger: "blur"
        }],
        show_switch: [{
          required: true,
          message: this.$t('pleaseChoose'),
          trigger: "blur"
        }]
      },
      isMobile: false
    };
  },
  created: function created() {
    this.checkMobile();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize: function handleResize() {
      this.checkMobile();
    },
    labelChange: function labelChange(e) {
      var _this = this;

      if (e == 4 && this.paramsData.pause == 1) {
        this.paramsData.main_content.map(function (item) {
          if (item.language == 'cn') {
            item.content = _this.FillIn['cnT'];
          } else if (item.language == 'en') {
            item.content = _this.FillIn['enT'];
          } else if (item.language == 'tc') {
            item.content = _this.FillIn['tcT'];
          } else if (item.language == 'vn') {
            item.content = _this.FillIn['vnT'];
          }
        });
      }
    },
    addtag: function addtag(data, index) {
      this.paramsData.main_content[index].content = "".concat(this.paramsData.main_content[index].content).concat(data);
    },
    addContent: function addContent() {
      if (this.paramsData.main_content.length < this.langList.length) {
        this.paramsData.main_content.push({
          content: '',
          language: '',
          title: ''
        });
      }
    },
    removeContent: function removeContent(item) {
      var index = this.paramsData.main_content.indexOf(item);

      if (index !== -1) {
        this.paramsData.main_content.splice(index, 1);
      }
    },
    pauseChange: function pauseChange(e) {
      var _this2 = this;

      this.paramsData.main_content = [];
      this.$refs.ruleForm.clearValidate();
      this.paramsData.label = 0;

      if (e !== 0) {
        this.langList.forEach(function (i) {
          _this2.paramsData.main_content.push({
            content: (e == 1 ? _this2.FillIn : _this2.NewSuitlIn)[i.value],
            language: i.value,
            title: e == 1 ? _this2.FillInTitle[i.value] : _this2.NewSuitlInTitle[i.value]
          });
        });
      } else {
        this.paramsData.main_content = [{
          content: '',
          language: '',
          title: ''
        }];
      }
    },
    open: function open(data) {
      if (data) {
        data = JSON.parse(JSON.stringify(data));
        console.log("data==", data);

        if (data.start_time == -1) {
          data.start_time = '';
          this.isStart = true;
        } else {
          data.start_time = data.start_time;
          this.isStart = false;
        }

        if (data.end_time == -1) {
          data.end_time = '';
          this.isEnd = true;
        } else {
          data.end_time = data.end_time;
          this.isEnd = false;
        } // data.server_rangeStart = data.server_rangeList[0]
        // data.server_rangeEnd = data.server_rangeList[1]


        if (data.isNewData != '1') {
          if (Array.isArray(data.server_rangeList) && data.server_rangeList.length === 2) {
            var start = Number(data.server_rangeList[0]);
            var end = Number(data.server_rangeList[1]);

            if (!isNaN(start) && !isNaN(end) && start <= end) {
              data.server_rangeList = Array.from({
                length: end - start + 1
              }, function (_, i) {
                return start + i;
              });
            }
          }
        }

        data.server_range = data.server_rangeList;
        data.channel = data.channel == '-1' ? '' : data.channel;
        data.channel_list = data.channel_list ? data.channel_list.split(',') : []; // data.channelStart = data.channelList[0]
        // data.channelEnd = data.channelList[1]

        data.show_switch = data.show_switch ? 1 : 2;
        data.pause_start_time = data.pause_start_time ? data.pause_start_time : ''; // 兼容已发公告

        if (!data.main_content) {
          data.main_content = [{
            content: data.content,
            language: data.language,
            title: data.title
          }];
        }

        this.paramsData = _objectSpread(_objectSpread({}, this.paramsData), data); // force_push === 0 时转为否  

        this.paramsData.force_push = this.paramsData.force_push === 0 ? 2 : this.paramsData.force_push;
      } else {
        this.paramsData.main_content = [{
          content: '',
          language: '',
          title: ''
        }];
      }

      this.dialogShow = true;
    },
    hiad: function hiad() {
      this.dialogShow = false;
    },
    clearData: function clearData(isClearId) {
      this.paramsData = {
        id: isClearId ? '' : this.paramsData.id,
        label: 0,
        server_rangeStart: '',
        server_rangeEnd: '',
        channel: '',
        channel_list: [],
        // channelStart: '',
        // channelEnd: '',
        pause_start_time: '',
        // pause_duration: '',
        priority: '',
        force_push: '',
        start_time: '',
        end_time: '',
        show_switch: '',
        pause: 0,
        type: '',
        main_content: [{
          content: '',
          language: '',
          title: ''
        }]
      };
      this.isStart = false;
      this.isEnd = false;
      this.$refs.ruleForm.clearValidate();
    },
    isS: function isS(e, type) {
      this.paramsData[type] = '';
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this3 = this;

      this.$refs.ruleForm.clearValidate();
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          _this3.reqLoading = true;
          var params = JSON.parse(JSON.stringify(_this3.paramsData));
          var data = {
            // title: params.title,
            // content: params.content,
            // language: params.language,
            pause: params.pause,
            start_time: _this3.isStart ? -1 : params.start_time,
            end_time: _this3.isEnd ? -1 : params.end_time,
            label: parseInt(params.label),
            priority: parseInt(params.priority),
            force_push: parseInt(params.force_push),
            pause_start_time: params.pause_start_time ? params.pause_start_time : 0,
            // pause_duration: params.pause_duration,
            // pause_start_time: params.is_pause ? (params.pauseTime[0] / 1000) : '',
            // pause_end_time: params.is_pause ? (params.pauseTime[1] / 1000) : '',
            // server_range: params.server_rangeStart ? params.server_rangeEnd ? ([params.server_rangeStart, params.server_rangeEnd]).toString() : ([params.server_rangeStart, params.server_rangeStart]).toString() : '0',
            server_range: params.server_range.length ? params.server_range.join(",") : '0',
            show_switch: params.show_switch == 1 ? true : false,
            //channel: params.channelStart ? params.channelEnd ? ([params.channelStart, params.channelEnd]).toString() : ([params.channelStart, params.channelStart]).toString() : '-1',
            id: params.id,
            main_content: params.main_content,
            channel: params.channel ? params.channel : '',
            channel_list: params.channel_list ? params.channel_list.join(',') : ''
          };
          data = JSON.stringify([data]);
          var date = _this3.paramsData.type == 'new' ? _this3.paramsData.id ? _objectSpread(_objectSpread({
            data: data
          }, _this3.prod), {}, {
            id: params.id,
            game_id: _this3.rawData.game_id
          }) : _objectSpread(_objectSpread({
            data: data
          }, _this3.prod), {}, {
            game_id: _this3.rawData.game_id
          }) : _objectSpread(_objectSpread({
            data: data
          }, _this3.prod), {}, {
            game_id: _this3.rawData.game_id
          });
          coverAnnounce(date).then(function (res) {
            if (res.status == 200) {
              _this3.$message({
                message: _this3.$t('operationSuccess'),
                type: 'success'
              });

              _this3.dialogShow = false;

              _this3.$emit('update');
            }
          }).finally(function () {
            _this3.reqLoading = false;
          });
        }
      });
    }
  }
};